import { RootState } from '..'

const userToken = (state: RootState) => state.auth.access
const authState = (state: RootState) => state.auth
const userRoles = (state: RootState) => state?.auth?.userRoles
const userType = (state: RootState) => state?.auth?.userType
const userOrganization = (state: RootState) => state.auth?.organizationId
const userOrganizationType = (state: RootState) => state.auth?.organizationType
const userOrganizationTitle = (state: RootState) => state.auth?.organizationTitle
const userReportEditAccess = (state: RootState) => state?.auth?.userEditAccessOnReport
const userDetails = (state: RootState) => state.auth?.userDetails

export default {
  userToken,
  authState,
  userRoles,
  userType,
  userOrganizationTitle,
  userOrganization,
  userOrganizationType,
  userReportEditAccess,
  userDetails
}
